import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import {
  orderTerms,
  purchaseCompanies,
  purchaseOrdersStatuses,
  purchaseShippings
} from "../../../data";
import {
  addToArray,
  getAllOfCollection,
  getDocById,
  saveData,
  uniqueID,
  getDocByKeyValue
} from "../../../firebase/utility";
import { getDnhProductsByPartNumbers, getIngramPriceAvailability, getDistributorStock } from "../../../api/edi.api";
import { SHIPPING_IDENTIFIER } from "../../../utils/shippingIdentifier";
const useCreatePurchaseOrder = (props) => {
  const { state } = props.location;
  const { obj, vendor, directPO, tagSaleOrders } = state || {};

  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const [shippingData, setShippingData] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [loader, setLoader] = useState(false);
  const [billingData, setBillingData] = useState({});
  const [line_items, setLineItems] = useState(obj?.line_items ?? []);
  const [new_line_items, setNewLineItems] = useState([]);
  const [orderNotes, setOrderNotes] = useState(obj?.orderNotes ?? []);
  const [subTotal, setSubTotal] = useState(obj?.subTotal ?? 0);
  const [total, setTotal] = useState(obj?.total ?? 0);
  const [poNumber, setPoNumber] = useState(obj?.po_no ?? "");
  const [status, setStatus] = useState("");
  const [vendorPoNumber, setVendorPoNumber] = useState("");
  const [freightBillingAccount, setFreightBillingAcc] = useState('')
  const [pageLoader, setPageLoader] = useState(false);
  const [dnhData, setDnhData] = useState([]);
  const [ingramData, setIngramData] = useState([]);
  const [distributorStockData, setDistributorStockData] = useState([]);
  const [distributorStockLoading, setDistributorStockLoading] = useState(false);
  const [purchaseOrderStatus, setPurchaseOrderStatus] = useState(
    purchaseOrdersStatuses.find((i) => i.label === obj?.purchaseOrderStatus)?.label ?? "active"
  );
  const [terms, setTerms] = useState(
    orderTerms?.find((i) => i?.value === vendor?.billing?.[0]?.terms)?.value ?? ""
  );
  const [shipping, setShipping] = useState(
    purchaseShippings?.find((i) => i?.value === obj?.shipBy)?.value ?? ""
  );
  const [company, setCompany] = useState(
    purchaseCompanies?.find((i) => i?.value === obj?.company)?.value ?? (obj?.company || "Cheapest Option")
  );
  const [vendorInstructions, setVendorInstructions] = useState(
    obj?.vendorInstructions ?? vendor?.vendorInstructions ?? vendor?.billing?.[0]?.vendorInstructions ?? ""
  );
  const [orderNote, setOrderNote] = useState(obj?.orderNote ?? "");
  const [addressType, setAddressType] = useState(obj?.addressType || "COMMERCIAL");
  const [signatureRequired, setSignatureRequired] = useState(obj?.signatureRequired || "");
  const [tm, setTm] = useState(false);
  const [usAddresses, setUsAddresses] = useState([]);
  const [selectedUSAddressId, setSelectedUSAddressId] = useState("");

  useEffect(() => {
    getAllOfCollection("USAddresses").then((res) => {
      setUsAddresses(res || []);
      if (res && res.length > 0) {
        setSelectedUSAddressId(res[0]._id || res[0].id);
      }
    });
  }, []);
  const [totalTaxAmount, setTotalTaxAmount] = useState({
    tax: 0,
    shipping: 0,
  });
  const [shippingCheckboxes, setShippingCheckboxes] = useState({
    do_not_email: obj?.shippingCheckboxes?.do_not_email ?? false,
  });
  const [itemModal, setItemModal] = useState(false);
  const toggleItemModal = () => {
    setItemModal(!itemModal);
  };
  const calculateTotal = async () => {
    let calculate_total_amount =
      parseFloat(subTotal) +
      parseFloat(totalTaxAmount?.tax) +
      parseFloat(totalTaxAmount?.shipping);
    setTotal(calculate_total_amount);
  };
  const soLineItems = (!directPO && obj?.line_items) ? obj.line_items : [];

  const handleCreate = async () => {
    setLoader(true);

    try {

      if (!company || company === "" || company === null) {
        toast.error("Company (Carrier) is required!");
        setLoader(false);
        return;
      }

      if (!poNumber || isNaN(Number(poNumber))) {
        toast.error("PO Number is missing or invalid. Please reload and try again.");
        setLoader(false);
        return;
      }

      // Validate PO quantity against parent Sales Order quantity
      if (!directPO && soLineItems?.length > 0) {
        for (const item of line_items || []) {
          const orderedQty = parseInt(item?.quantity ?? 0);
          const soItem = soLineItems.find((soIt) =>
            (soIt.sku && item.sku && soIt.sku.toLowerCase() === item.sku.toLowerCase())
          );
          if (soItem && orderedQty > parseInt(soItem.quantity ?? 0)) {
            toast.error(
              `PO quantity (${orderedQty}) for "${item.sku || item.name || 'Item'}" cannot exceed Sales Order quantity (${soItem.quantity}).`
            );
            setLoader(false);
            return;
          }
        }
      }

      const vendorData = {
        ...billingData,
        terms,
        vendorQuickBooksId: vendor?.quickbooks_id,
      };

      const mappedLineItems = (line_items || []).map((item) => ({
        ...item,
        quantity: parseInt(item?.quantity ?? 0),
      }));

      const finalObj = {
        line_items: mappedLineItems,
        shippingCheckboxes,
        vendor: vendorData,
        shipping: shippingData,
        customer: customerData,
        vendorInstructions,
        orderNote,
        total,
        totalTaxAmount,
        subTotal,
        vendorId: vendor?.quickbooks_id,
        vendorOrderId: vendor?.id,
        po_no: poNumber,
        saleOrderId: obj?._id ?? "",
        purchaseOrderStatus: purchaseOrderStatus ?? "active",
        company,
        id: poNumber,
        vendorPoNumber,
        _id: uniqueID(),
        shippingVia: shipping,
        directPO: !!directPO,
        shippingIdentifier: tm
          ? SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO
          : SHIPPING_IDENTIFIER.DIRECT_SHIP,
        tagSaleOrders: tagSaleOrders ?? [],
        freightBillingAccount: freightBillingAccount ?? "",
        addressType: addressType || "COMMERCIAL",
        signatureRequired: signatureRequired || "",
        created_at: Date.now(),
        created_by: {
          username: user?.username || "",
          email: user?.email || "",
          _id: user?._id || "",
        },
      };

      const counterRes = await getDocById("counters", "PurchaseOrders");

      if (!counterRes) {
        toast.error("Failed to fetch PO counter from backend.");
        setLoader(false);
        return;
      }

      const backendID = Number(counterRes?.currentID);

      if (Number.isNaN(backendID)) {
        toast.error("PO ID from backend is not a valid number. Please check backend data.");
        setLoader(false);
        return;
      }

      if (backendID === parseInt(poNumber)) {
        toast.error("PO Number already exists in backend counter. Please try again.");
        setLoader(false);
        return;
      }


      const saveRes = await saveData("PurchaseOrders", finalObj._id, finalObj);
      if (!saveRes) {
        toast.error("Failed to create Purchase Order. Please try again.");
        setLoader(false);
        return;
      }


      await saveData("counters", "PurchaseOrders", {
        currentID: parseInt(poNumber),
      });


      createAdminNotification({
        title: "Purchase Order Created",
        message: `Purchase Order #${finalObj.id || poNumber} was created by ${user?.username || "Admin"}`,
        category: "purchase_order",
        entityId: String(finalObj.id || poNumber),
        targetUrl: `/admin/purchase-orders-details/${finalObj._id || finalObj.id}`,
        actor: user,
      }).catch(console.error);

      if (directPO) {
        toast.success(`Purchase Order ${finalObj.id} created successfully!`);
        setLoader(false);
      } else {
        await addToArray("Orders", obj?._id, "logs", {
          createdAt: Date.now(),
          createdBy: user,
          message: `Purchase Order ${poNumber} was generated for the order!`,
        });

        toast.success(`Purchase Order ${finalObj.id} created successfully!`);

        setLoader(false);


        history.push({
          pathname: `/admin/generate-purchase-orders-details/${finalObj._id}`,
          state: {
            obj: {
              po_no: poNumber,
              shippingVia: shipping,
              company,
              ...finalObj,
            },
            id: obj?.id,
            vendor: {
              billing: [vendor?.billing?.[0]],
              id: vendor?.id,
              _id: obj?.vendor?.id,
            },
            saleOrderCheck: true,
          },
        });
      }
    } catch (error) {
      console.error("Error creating PO:", error);
      toast.error("An error occurred while creating the Purchase Order.");
      setLoader(false);
    }
  };

  // USEEFFECT HOOKS ++++++++++++++++++++++++++++++++++++++++++++++++
  useEffect(() => {
    let subtotal = 0;
    line_items.forEach((item) => {
      const quantity = parseInt(item.quantity);
      const price = parseFloat(item.price ?? 0);
      console.log(quantity, price, quantity * price);
      subtotal += quantity * price;
    });
    setSubTotal(subtotal?.toFixed(2));
    setTotal(subtotal?.toFixed(2));
  }, [line_items]);
  useEffect(() => {
    calculateTotal();
  }, [totalTaxAmount, line_items, subTotal]);
  useEffect(() => {
    if (obj) {
      getDocById("counters", "PurchaseOrders").then((res) => {
        if (res) {
          const id = Number(res?.currentID);
          if (Number.isNaN(id)) {
            toast.error("PO ID from backend is invalid. Please check the counter setup.");
          } else {
            setPoNumber(String(id + 1));
          }
        }
      });
    }
  }, [obj]);

  useEffect(() => {
    if (state) {
      setShippingData({
        company: obj?.shipping?.company ?? "",
        first_name: obj?.shipping?.first_name ?? "",
        last_name: obj?.shipping?.last_name ?? "",
        address_1: obj?.shipping?.address_1 ?? "",
        address_2: obj?.shipping?.address_2 ?? "",
        city: obj?.shipping?.city ?? "",
        state: obj?.shipping?.state ?? "",
        phone: obj?.shipping?.phone ?? "",
        postcode: obj?.shipping?.postcode ?? "",
        email: obj?.shipping?.email ?? "",
        quickbooks_id: obj?.customer_id ?? "",
      });
      setCustomerData({
        company: obj?.shipping?.company ?? "",
        first_name: obj?.shipping?.first_name ?? "",
        last_name: obj?.shipping?.last_name ?? "",
        address_1: obj?.shipping?.address_1 ?? "",
        address_2: obj?.shipping?.address_2 ?? "",
        city: obj?.shipping?.city ?? "",
        state: obj?.shipping?.state ?? "",
        phone: obj?.shipping?.phone ?? "",
        postcode: obj?.shipping?.postcode ?? "",
        email: obj?.shipping?.email ?? "",
        quickbooks_id: obj?.customer_id ?? "",
      });
      setBillingData({
        company: vendor?.billing[0]?.company ?? "",
        originalCompany: vendor?.billing[0]?.company ?? "",
        first_name: vendor?.billing[0]?.first_name ?? "",
        last_name: vendor?.billing[0]?.last_name ?? "",
        address_1: vendor?.billing[0]?.address_1 ?? "",
        address_2: vendor?.billing[0]?.address_2 ?? "",
        city: vendor?.billing[0]?.city ?? "",
        state: vendor?.billing[0]?.state ?? "",
        phone: vendor?.billing[0]?.phone ?? "",
        postcode: vendor?.billing[0]?.postcode ?? "",
        email: vendor?.billing[0]?.email ?? "",
        dba: vendor?.billing?.[0]?.dba ?? vendor?.dba ?? [],
        selectedDBA: "",
      });
    }
  }, [vendor, obj]);
  const [checks, setchecks] = useState(true);
  useEffect(() => {
    if (tm) {
      const addr = usAddresses.find(a => (a._id === selectedUSAddressId || a.id === selectedUSAddressId)) || usAddresses[0];
      if (addr) {
        setShippingData({
          first_name: addr.first_name || "",
          last_name: addr.last_name || "",
          address_1: addr.address_1 || "",
          address_2: addr.address_2 || "",
          company: addr.company || "",
          country: addr.country || "USA",
          state: addr.state || "",
          phone: addr.phone || "6305261800",
          email: addr.email || "",
          city: addr.city || "",
          postcode: addr.postcode || "",
          quickbooks_id: addr.quickbooks_id || "",
        });
        setStatus("Coming To TMUSA");
      } else {
        setShippingData({
          first_name: "Receiving",
          last_name: "Department",
          address_1: "206 Far Hill Drive",
          address_2: "",
          company: "TechMicro USA INC",
          country: "USA",
          state: "IL",
          phone: "6305261800",
          email: "purchasing@techmicrousa.com",
          city: "Bolingbrook",
          postcode: "60440",
          quickbooks_id: "613",
        });
        setStatus("Coming To TMUSA");
      }
    } else {
      setShippingData({
        company: obj?.shipping?.company ?? "",
        first_name: obj?.shipping?.first_name ?? "",
        last_name: obj?.shipping?.last_name ?? "",
        address_1: obj?.shipping?.address_1 ?? "",
        address_2: obj?.shipping?.address_2 ?? "",
        city: obj?.shipping?.city ?? "",
        state: obj?.shipping?.state ?? "",
        phone: obj?.shipping?.phone ?? "",
        postcode: obj?.shipping?.postcode ?? "",
        email: obj?.shipping?.email ?? "",
        quickbooks_id: obj?.customer_id ?? "",
      });
    }
  }, [tm, selectedUSAddressId, usAddresses])
  useEffect(() => {
    if (directPO) {
      setTm(true)
    }
  }, [directPO])
  useEffect(() => {
    const currentLineItems = line_items?.length > 0 ? line_items : (state?.obj?.line_items || []);
    if (currentLineItems?.length > 0) {
      const skus = currentLineItems
        .map((item) => item.sku || item.parts)
        .filter(Boolean);

      if (skus.length > 0) {
        setDistributorStockLoading(true);
        getDistributorStock(skus, (response) => {
          setDistributorStockLoading(false);
          if (response?.status === 200 && response?.data?.data) {
            setDistributorStockData(response.data.data);
          }
        });
      }

      setFreightBillingAcc(state?.obj?.customer_acc);
    }
  }, [state, line_items]);
  return {
    state,
    vendor,
    obj,
    line_items,
    setLineItems,
    orderNotes,
    setOrderNotes,
    subTotal,
    total,
    poNumber,
    setPoNumber,
    terms,
    setTerms,
    shipping,
    setShipping,
    company,
    setCompany,
    vendorInstructions,
    setVendorInstructions,
    orderNote,
    setOrderNote,
    totalTaxAmount,
    setTotalTaxAmount,
    shippingCheckboxes,
    setShippingCheckboxes,
    itemModal,
    toggleItemModal,
    handleCreate,
    shippingData,
    setShippingData,
    setCustomerData,
    customerData,
    billingData,
    setBillingData,
    freightBillingAccount, setFreightBillingAcc,
    checks,
    vendorPoNumber,
    setVendorPoNumber, directPO, pageLoader, setPageLoader, dnhData, setDnhData,
    ingramData, setIngramData, distributorStockData, distributorStockLoading,
    loader, purchaseOrderStatus, setPurchaseOrderStatus, new_line_items, setNewLineItems, tm, setTm, usAddresses, selectedUSAddressId, setSelectedUSAddressId, soLineItems,
    addressType, setAddressType, signatureRequired, setSignatureRequired,
  };
};
export default useCreatePurchaseOrder;
